document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('quick-subscribe-modal');
  var buttons = document.getElementsByClassName('quick-subscribe-button');
  var span = document.querySelector('.quick-subscribe-close');
  var form = document.getElementById('quick-subscribe-form');
  var productTitleElem = document.getElementById('quick-subscribe-product-title');
  var variantTitleElem = document.getElementById('quick-subscribe-variant-title');
  var productImageElem = document.getElementById('quick-subscribe-product-image');
  var productPriceElem = document.getElementById('quick-subscribe-product-price');
  var variantSelect = document.getElementById('quick-subscribe-variant-select');
  var tagsInput = document.getElementById('quick-subscribe-tags');
  var successMessage = document.getElementById('quick-subscribe-success-message');
  var currentProductId = null;
  var top_parent = document.getElementById('main');

  // Remove any existing phone number validation
  var phoneInput = document.getElementById('quick-subscribe-phone');
  if (phoneInput) {
    phoneInput.pattern = '.*'; // This allows any input
    phoneInput.title = 'Enter your phone number with or without +';
  }

  // Remove the Name input if it exists
  var nameInput = document.getElementById('quick-subscribe-name');
  if (nameInput && nameInput.parentNode) {
    nameInput.parentNode.removeChild(nameInput);
  }

  // Add a honeypot field
  var honeypotField = document.createElement('input');
  honeypotField.type = 'text';
  honeypotField.name = 'bot-field';
  honeypotField.style.display = 'none';
  form.appendChild(honeypotField);

  // Function to save form data to localStorage
  function saveFormData() {
    var phoneValue = document.getElementById('quick-subscribe-phone').value.trim();
    var emailValue = document.getElementById('quick-subscribe-email').value.trim();
    var formData = {
      phone: phoneValue,
      email: emailValue,
      tags: tagsInput.value,
      productId: currentProductId
    };
    localStorage.setItem('quickSubscribeFormData', JSON.stringify(formData));
  }

  // Function to load form data from localStorage
  function loadFormData() {
    var formDataString = localStorage.getItem('quickSubscribeFormData');
    if (formDataString) {
      var formData = JSON.parse(formDataString);
      document.getElementById('quick-subscribe-phone').value = formData.phone || '';
      document.getElementById('quick-subscribe-email').value = formData.email || '';
      tagsInput.value = formData.tags || '';
      currentProductId = formData.productId;
      return true;
    }
    return false;
  }

  // Function to clear form data from localStorage
  function clearFormData() {
    localStorage.removeItem('quickSubscribeFormData');
  }

  // Function to format phone number for tag
  function formatPhoneForTag(phone) {
    // Remove all non-digit characters
    return phone.replace(/\D/g, '');
  }

  // Check if there's saved form data and show success message if needed
  if (loadFormData()) {
    updateSubscribeButton();
    if (successMessage) {
      successMessage.style.display = 'block';
    }
    // Don't clear form data here to ensure it's available after CAPTCHA reload
  }

  Array.from(buttons).forEach(function(button) {
    button.addEventListener('click', function() {
      var productId = button.getAttribute('data-product-id');
      var variantId = button.getAttribute('data-variant-id');
      var productTitle = button.getAttribute('data-product-title');
      var variantTitle = button.getAttribute('data-variant-title');
      var productPrice = button.getAttribute('data-product-price');
      var productImage = button.getAttribute('data-product-image');

      currentProductId = productId;

      tagsInput.value = `newsletter,quick_buy_${productId}_${variantId}`;
      productTitleElem.textContent = productTitle;
      variantTitleElem.textContent = variantTitle;
      productPriceElem.innerHTML = `<span class="money">${productPrice}</span>`;
      productImageElem.src = productImage;

      if (variantSelect) {
        variantSelect.value = variantId;
      }

      modal.style.display = 'block';
      top_parent.classList.add('subcribe-popup');

      adjustScrollForModal();
    });
  });

  if (span) {
    span.addEventListener('click', function() {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      top_parent.classList.remove('subcribe-popup');
    });
  }

  window.addEventListener('click', function(event) {
    if (event.target == modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      top_parent.classList.remove('subcribe-popup');
    }
  });

  if (form) {
    var lastSubmitTime = 0;
    var submitDelay = 2000; // 2 seconds

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var currentTime = Date.now();
      if (currentTime - lastSubmitTime < submitDelay) {
        console.log('Form submission too frequent. Please wait.');
        return;
      }
      lastSubmitTime = currentTime;

      // Check if honeypot field is filled (bot detection)
      if (honeypotField.value !== '') {
        console.log('Bot detected. Form submission prevented.');
        return;
      }

      var phoneValue = document.getElementById('quick-subscribe-phone').value.trim();
      var formattedPhone = formatPhoneForTag(phoneValue);

      // Update tags including phone number
      var currentTags = tagsInput.value.split(',');
      currentTags = currentTags.filter(tag => !tag.startsWith('phone_'));
      if (formattedPhone) {
        currentTags.push('phone_' + formattedPhone);
      }
      currentTags.push('newsletter');
      tagsInput.value = currentTags.join(',');

      console.log('Updated tags value:', tagsInput.value);

      // Save form data before submission
      saveFormData();

      // Create FormData after updating tagsInput.value
      var formData = new FormData(form);

      // Update 'contact[tags]' field in FormData
      formData.set('contact[tags]', tagsInput.value);

      // Serialize form data
      var formBody = [];
      formData.forEach(function(value, key) {
        formBody.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      formBody = formBody.join('&');

      // Send form via AJAX
      fetch(form.action, {
        method: form.method,
        body: formBody,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(function(response) {
        if (response.ok) {
          modal.style.display = 'none';

          // Update button on the page
          updateSubscribeButton();

          document.body.style.overflow = '';
          top_parent.classList.remove('subcribe-popup');

          // Show success message under the button
          if (successMessage) {
            successMessage.style.display = 'block';
          }

          console.log('Form successfully submitted');
          clearFormData(); // Clear form data after successful submission
        } else {
          console.error('Form submission failed');
          // Keep the saved form data in case of failure
        }
      })
      .catch(function(error) {
        console.error('Form submission error:', error);
        // Keep the saved form data in case of error
      });
    });
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      var selectedOption = this.options[this.selectedIndex];
      var variantId = selectedOption.getAttribute('data-variant-id');
      var variantTitle = selectedOption.getAttribute('data-variant-title');
      var variantPrice = selectedOption.getAttribute('data-variant-price');
      var variantImage = selectedOption.getAttribute('data-variant-image');
      var productId = variantSelect.getAttribute('data-product-id');

      tagsInput.value = `newsletter,quick_buy_${productId}_${variantId}`;
      variantTitleElem.textContent = variantTitle;
      productPriceElem.innerHTML = `<span class="money">${variantPrice}</span>`;
      productImageElem.src = variantImage;

      adjustScrollForModal();
    });
  }

  function adjustScrollForModal() {
    var modalContent = document.querySelector('.quick-subscribe-modal-content');
    if (modalContent) {
      var modalHeight = modalContent.offsetHeight;
      var windowHeight = window.innerHeight;
      if (modalHeight > windowHeight) {
        document.body.style.overflow = 'auto';
      } else {
        document.body.style.overflow = 'hidden';
      }
    }
  }

  function updateSubscribeButton() {
    if (currentProductId) {
      var button = document.querySelector(`.quick-subscribe-button[data-product-id="${currentProductId}"]`);
      if (button) {
        button.textContent = 'Quick Order Placed';
        button.style.backgroundColor = '#ccc';
        button.style.color = '#666';
        button.style.borderColor = '#ccc';
        button.disabled = true;
      }
    }
  }
});